import axios from 'axios';

// 환경에 따른 기본 URL 설정
const BASE_URL = process.env.REACT_APP_API_URL;

// axios 인스턴스 생성
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // 10초 타임아웃
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // 쿠키를 요청에 포함
});

// 응답 인터셉터 - 공통 에러 처리
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 에러 (인증 실패) 처리
    if (error.response && error.response.status === 401) {
      // 로그인 페이지로 리다이렉트 또는 다른 처리
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
